/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Fields every person of a type has without an org data key.
 */
export enum BuiltinField {
  SUBJECTS = "subjects",
  PAYMENT_METHOD = "payment_method",
  LAST_MEETING_DATE = "last_meeting_date",
  NEXT_MEETING_DATE = "next_meeting_date",
  BALANCE_OWED = "balance_owed",
  CREDIT_BALANCE = "credit_balance",
  LAST_CONTACTED = "last_contacted",
  MEETINGS_LAST_30_DAYS = "meetings_last_30_days",
  FORM_FILLED_OUT = "form_filled_out",
  FORM_FILLED_OUT_DATE = "form_filled_out_date",
}
